import axios from 'axios'

export default {
    async sendErrorHandler(data) {
        try{            
            const response = await axios.post(`Email/send-error-handler`, data)            
            return response
        }catch (error){
            console.log('Email api sendErrorHandler error')
            throw error
        }
    },
}